import getDashboardName from 'common/src/modules/analytics/utils/getDashboardName';
import {refreshDashboards} from 'common/src/modules/campaigns/store/insightsPage/features';
import dashboardsApi from 'common/src/modules/dashboards/dashboards.api';
import {Dashboard} from 'common/src/modules/dashboards/dashboards.types';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {CLStore} from 'common/src/redux/store';
import _find from 'lodash/find';
import _map from 'lodash/map';
import {z} from 'zod';
import {CampaignAnalyticsToolName} from '../campaignAnalyticsAgent.enums';

const inputSchema = z.object({
  dashboardId: z.number().describe('The ID of the editable dashboard to rename'),
  newDashboardName: z.string().describe('The new name of the dashboard'),
});

function renameDashboardTool(store: CLStore) {
  async function execute({
    input: {dashboardId, newDashboardName},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const state = store.getState();
    const {
      campaignPage: {
        insightsPage: {dashboards},
      },
    } = state;

    const campaignDashboards = _map(dashboards, (dashboard) => ({
      ...dashboard,
      name: getDashboardName(dashboard),
    }));

    const dashboard = _find(campaignDashboards, {id: dashboardId});

    if (!dashboard) {
      return toolError('Dashboard not found');
    }

    await dashboardsApi.updateDashboard({
      ...dashboard,
      name: newDashboardName,
    } as Dashboard);

    store.dispatch(refreshDashboards());

    return toolResult('Dashboard renamed successfully');
  }

  return tool({
    name: CampaignAnalyticsToolName.RenameDashboard,
    displayName: 'Renaming dashboard',
    description: 'rename a dashboard',
    execute,
    inputSchema,
  });
}

export default renameDashboardTool;
